import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface AdminRouteProps {
  children: React.ReactNode;
}

/** Only users with `invoice_permission` admin or super_admin may access the wrapped route. */
const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user } = useAuth();
  const isAdmin =
    user?.invoice_permission === 'admin' || user?.invoice_permission === 'super_admin';
  if (!isAdmin) {
    return <Navigate to="/ims/invoices" replace />;
  }
  return <>{children}</>;
};

export default AdminRoute;
